import { ACTION_CODES, ERROR_CODES } from 'constants/errors';
import { flatten } from 'ramda';

class AgentPortalError extends Error {
  constructor({ message, graphQLErrors }, actionCode, errorData) {
    super(message);
    this.graphQLErrors = AgentPortalError.flattenGraphQLErrors(graphQLErrors);
    this.errorData = errorData;

    if (this.graphQLErrors.find((error) => error.extensions.code === ERROR_CODES.S3_AUTHORISATION_ERROR)) {
      this.actionCode = ACTION_CODES.REDIRECT_TO_LOGIN_PAGE;
    } else {
      this.actionCode = actionCode;
    }
  }

  static flattenGraphQLErrors = (graphQLErrors = []) =>
    flatten(graphQLErrors.map((e) => (e.graphQLErrors ? [...AgentPortalError.flattenGraphQLErrors(e.graphQLErrors)] : [e])));
}

export default AgentPortalError;
